import { toast } from 'react-toastify';

export const ErrorAction = {
	CREATE: 'Ajout',
	READ: 'Récupération',
	UPDATE: 'Modification',
	DELETE: 'Suppression',
};

export const ErrorMessage = {
	HTTP400ErrorGeneric: 'BadRequest',
	HTTP400ErrorIncompleteBody: 'IncompleteBody',
	HTTP400ErrorBadType: 'BadType',
	HTTP401ErrorGeneric: 'NotAuth',
	HTTP403ErrorGeneric: 'Forbidden',
	HTTP404ErrorGeneric: 'NotFound',
	HTTP409ErrorGeneric: 'Conflict',
	HTTP500ErrorGeneric: 'ServerError',
};

export const errorHandler = (entity, errorAction, error) => {
	const messageBase = `${entity} - ${errorAction} impossible,`;
	if (error.response ) {
		switch (error.response.status) {
			case 400:
				if (error.response.data && error.response.data.message === ErrorMessage.HTTP400ErrorIncompleteBody)
					toast.error(`${messageBase} il manque certaines données`);
				if (error.response.data && error.response.data.message === ErrorMessage.HTTP400ErrorBadType)
					toast.error(`${messageBase} le type de fichier utilisé n'est pas supporté`);
				else
					toast.error(`${messageBase} les données envoyées ne sont pas bonnes`);
				break;
			case 401:
				toast.error(`${messageBase} vous n'êtes pas authentifié`);
				break;
			case 403:
				toast.error(
					`${messageBase} vous n'êtes pas autorisé à faire cette action`
				);
				break;
			case 404:
				toast.error(`${messageBase} ${entity.toLowerCase()} non trouvé(e)`);
				break;
			case 409:
				if (errorAction === ErrorAction.DELETE)
					toast.error(
						`${messageBase} cet enregistement est utilisé dans des tables de la base de données`
					);
				else
					toast.error(
						`${messageBase} il existe déjà un enregistrement avec ces valeurs`
					);
				break;
			case 500:
				toast.error(
					`${messageBase} une erreur s'est produite du côté du serveur`
				);
				break;
			default:
				toast.error(
					`${messageBase} une erreur s'est produite du côté du serveur`
				);
				break;
		}
	}
	else{
		toast.error(
			`${messageBase} une erreur s'est produite du côté du serveur`
		);
	}
};
